export default __webpack_public_path__ + "static/video-bg-74e03be6992b30279a3883279e5510d5.jpg";